<template>
  <v-container
    class="stats-view"
    fluid
    fill-height
    align-center
    justify-center
  >
  <v-progress-circular indeterminate="" v-if="loading">
      </v-progress-circular
    >
    <v-layout v-if="!loading" column justify-center >
      
        <div class="header"> Survey Widget Stats </div>
        <v-layout  justify-center>
          <v-flex xs4 class='stat' text-xs-center>
            <div class='stat-number'>{{stats.feedback_shown_count}}</div>
            <div class='stat-label'>Shown</div>
          </v-flex>
          <v-flex xs4 class='stat' text-xs-center>
            <div class='stat-number'>{{stats.response_count}}</div>
            <div class='stat-label'>Total Responses</div>
          </v-flex>
          <v-flex xs4 class='stat' text-xs-center>
            <div class='stat-number'>{{stats.response_percent}}%</div>
            <div class='stat-label'>Response Rate</div>
          </v-flex>
        </v-layout>
      
        <div class="header"> Proof Widget Stats </div>
        <v-layout justify-center>
          <v-flex xs4 class='stat' text-xs-center>
            <div class='stat-number'>{{stats.proof_shown_count}}</div>
            <div class='stat-label'>Shown</div>
          </v-flex>
          
        </v-layout>
      
    </v-layout>
  </v-container>
</template>

<script>
import formMixins from '@/mixins/forms'
import insightsApi from '@/api/insights'
import Verte from 'verte'
import 'verte/dist/verte.css'
export default {
  mixins: [formMixins],
  components: { Verte },
  name: 'StatsView',
  props: {
    campaign: {
      type: Object,
      default: function() {
        return {
          
        }
      }
    }
  },
  created(){
    const vm = this
    insightsApi.getStats(this.$store.getters['user/currentCampaign'].id).then(function(data){
      vm.loading = false
      vm.stats = data.data.results
      console.log(data)
    })
  },
  data: function() {
    return {
      stats: null,
      loading: true
    }
  },
  
  methods: {
    
  }
}
</script>

<style lang="stylus">
.stats-view {
  .header {
    font-size 16px
    font-weight 500
    border: 1px solid $color-primary-light-1
    border-radius 5px
    padding 8px 25px
    max-width: 210px
    margin: 70px auto 70px auto;
  }
  .stat {
    .stat-number {
      font-size 36px
      margin-bottom 10px
    }
    .stat-label {
      color: $color-primary-light-5
      font-size: 18px
    }
  }
}
</style>
